import axios from 'axios';

import { applyBearerAuthHeader } from './auth-token';
import { isBearerAuthMode } from './auth-mode';
import { getApiBaseUrl } from './runtime-urls';

const $axios = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  withCredentials: !isBearerAuthMode(),
});

$axios.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }
  applyBearerAuthHeader(config.headers as Record<string, string | undefined>);
  return config;
});

$axios.interceptors.response.use((resp) => {
  const v = resp.headers['x-assembly-version'] || 'default';
  if (v !== localStorage.getItem('x-assembly-version') && resp.config.method === 'get') {
    localStorage.setItem('x-assembly-version', v);
    //window.location.reload();
  }
  return Promise.resolve(resp);
});

export default $axios;
